import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useCreatePath, useRecordContext } from 'react-admin';

import { Permissions } from '@src/global/permissions';

import { classToResource } from '@src/utils/model-helpers';

const EditResourceButton = ({ record }) => {
    const contextRecord = useRecordContext();
    const currentRecord = record || contextRecord;
    const createPath = useCreatePath();

    if (!currentRecord) {
        return null;
    }

    const resourceTypeRaw = currentRecord.feedable_type || currentRecord.record_type || currentRecord.exportable_type || currentRecord.searchable_type || currentRecord.resource_type;
    const resourceId = currentRecord.feedable_id || currentRecord.record_id || currentRecord.exportable_id || currentRecord.searchable_id || currentRecord.resource_id;

    if (!resourceTypeRaw || !resourceId) {
        return null;
    }

    const resource = classToResource(resourceTypeRaw);

    if (resource === 'social_sharings' || resource === 'field_management_news' || resource === 'articles') {
        return null;
    }

    if (Permissions(resource, 'update') === false) {
        return null;
    }

    const linkToResource = createPath({ resource, id: resourceId, type: 'edit' });

    return (
        <Button
            color="primary"
            endIcon={<OpenInNewIcon />}
            href={linkToResource}
            rel="noopener noreferrer"
            startIcon={<EditIcon />}
            target="_blank"
        >
            Edit
        </Button>
    );
};

EditResourceButton.propTypes = {
    record: PropTypes.shape({
        record_type: PropTypes.string,
        record_id: PropTypes.number,
        feedable_type: PropTypes.string,
        feedable_id: PropTypes.number,
        exportable_type: PropTypes.string,
        exportable_id: PropTypes.number,
        searchable_type: PropTypes.string,
        searchable_id: PropTypes.number,
        resource_type: PropTypes.string,
        resource_id: PropTypes.number,
    }),
};

export default EditResourceButton;
